module.exports = __webpack_public_path__ + "img/orange_064.95183ba3.png";